/**
 * ユーザーCSV関連
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../constants/httpConst'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/settings/users`

 const setting_user = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * @param commit
     * @param params
     * @return {Promise<unknown>}
     */
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params, {headers: {'content-type': 'multipart/form-data'}}).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },

  },
  mutations: {
  },
}

export default setting_user
